import {
    FETCH_CURRENT_USER_INFO_FETCHING,
    FETCH_CURRENT_USER_INFO_SUCCESS,
    FETCH_CURRENT_USER_INFO_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    userInfo: {},
    userInfoFetching: false,
    userInfoFetchSuccess: false,
    userInfoFetchFail: false
};

// ======= Fetching Handlers =======
const currentUserInfoFetching = (state) => {
    return {
        ...state,
        userInfoFetching: true,
        userInfoFetchSuccess: false,
        userInfoFetchFail: false
    };
};

const currentUserInfoFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        userInfo: success ? action.userInfo : state.userInfo,
        userInfoFetching: false,
        userInfoFetchSuccess: success,
        userInfoFetchFail: !success
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_CURRENT_USER_INFO_FETCHING]: currentUserInfoFetching,
    [FETCH_CURRENT_USER_INFO_SUCCESS]: currentUserInfoFetchFinished(true),
    [FETCH_CURRENT_USER_INFO_FAIL]: currentUserInfoFetchFinished(false)
};

// ======= Default Action =======
export default function currentUserInfo(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======

export const getCurrentUserInfo = (state) => {
    return state.currentUserInfo.userInfo;
};

export const getSocialNetwork = (state) => {
    return state.currentUserInfo.userInfo.socialNetwork;
};

export const getSocialIcon = (state) => {
    return state.currentUserInfo.userInfo.socialIcon;
};

export const getEmailAddress = (state) => {
    return state.currentUserInfo.userInfo.emailAddress;
};

export const isCurrentUserInfoFetching = (state) => {
    return state.currentUserInfo.userInfoFetching;
};

export const didCurrentUserInfoFetchFail = (state) => {
    return state.currentUserInfo.userInfoFetchFail;
};
